import React from 'react';
import { Row, Col, Badge } from 'reactstrap';
import dayjs from 'dayjs';
import HeatMapChart from '../Charts/HeatMapChart.jsx';

class WHeatmapPanel extends React.Component {
  constructor(props) {
    super();
    this.state = {
    };
    this.weekSummaryData = [];
  }

  componentWillReceiveProps(nextProps) {
    this.updateVisualData(nextProps)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.filterTimeStamp !== this.props.filterTimeStamp)
      return true;
    return false
  }

  updateVisualData(props) {
    let {
      dataListEMDs,
      filterResults,
    } = props;

    // week summary
    let dateMin = dayjs(Math.min(...filterResults.map(i => dataListEMDs[i].t)))
    let dateMax = dayjs(Math.max(...filterResults.map(i => dataListEMDs[i].t)))
    let dateStart = dateMin.subtract(dateMin.day(), 'day')
    let weekCount = Math.ceil(dateMax.diff(dateStart, 'day') / 7)
    this.weekSummaryData = new Array(weekCount).fill(0);
    filterResults.forEach(i => {
      let weekIndex = Math.floor(dayjs(dataListEMDs[i].t).diff(dateStart, 'day') / 7)
      this.weekSummaryData[weekIndex]++;
    })
    this.weekSummaryData = this.weekSummaryData.map((value, index) => ({
      index,
      value,
      name: `${dateStart.add(index*7, 'day').format('ll')} - ${dateStart.add(index*7+7, 'day').format('ll')}`
    }))
  }

  render() {
    return (
      <div>
        <Row>
          <Col xs={12}>
            <HeatMapChart
              width={400}
              height={50}
              data={this.weekSummaryData}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default WHeatmapPanel;
